const Connect = require("react-redux").connect;
const UpdateEmail = require("../components/UpdateEmail");
const AuthAct = require("actions/auth");

const internals = {};

internals.connect = Connect(null, {
    onSubmit: AuthAct.updateUserEmail
});

module.exports = internals.connect(UpdateEmail);



// WEBPACK FOOTER //
// ./src/routes/update-email/containers/UpdateEmail.js